import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import SplashScreen from './components/SplashScreen';
import PlateChecker from './components/PlateChecker';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import Pricing from './pages/Pricing';
import Account from './pages/Account';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Licenses from './pages/Licenses';
import DeleteAccount from './pages/DeleteAccount';
import TripPage from './pages/TripPage';
import Onboarding from './components/Onboarding';
import OfflineIndicator from './components/OfflineIndicator';
import ErrorBoundary from './components/ErrorBoundary';
import './App.css';
import { isNativePlatform } from './lib/capacitor';
import { App as CapApp } from '@capacitor/app';

export default function App() {
  const [splashComplete, setSplashComplete] = useState(() => {
    return localStorage.getItem('tlc_splash_seen') === 'true';
  });
  const [onboardingComplete, setOnboardingComplete] = useState(() => {
    return localStorage.getItem('tlc_onboarding_seen') === 'true';
  });
  const navigate = useNavigate();
  const location = useLocation();

  // Android hardware back button handling
  useEffect(() => {
    if (!isNativePlatform()) return;

    const listener = CapApp.addListener('backButton', ({ canGoBack }) => {
      if (location.pathname !== '/') {
        navigate(-1);
      } else {
        CapApp.exitApp();
      }
    });

    return () => { listener.then(l => l.remove()); };
  }, [location.pathname, navigate]);

  return (
    <>
      <OfflineIndicator />
      {!splashComplete && (
        <SplashScreen onComplete={() => setSplashComplete(true)} />
      )}
      {splashComplete && !onboardingComplete && (
        <Onboarding onComplete={() => setOnboardingComplete(true)} />
      )}
      <Routes>
        <Route path="/" element={<PlateChecker />} />
        <Route path="/login" element={<ErrorBoundary><Login /></ErrorBoundary>} />
        <Route path="/reset-password" element={<ErrorBoundary><ResetPassword /></ErrorBoundary>} />
        <Route path="/pricing" element={<ErrorBoundary><Pricing /></ErrorBoundary>} />
        <Route path="/account" element={<ErrorBoundary><Account /></ErrorBoundary>} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/licenses" element={<Licenses />} />
        <Route path="/delete-account" element={<ErrorBoundary><DeleteAccount /></ErrorBoundary>} />
        <Route path="/trip/:shortCode" element={<ErrorBoundary><TripPage /></ErrorBoundary>} />
      </Routes>
    </>
  );
}
